import { IThemeProperties } from 'lib/types/themes';
import { createContext, useContext } from 'react';

interface IThemeContext {
  properties: IThemeProperties;
}

export const ThemeContext = createContext<IThemeContext>(null);

export const useThemeContext = () => useContext(ThemeContext);
